import React from 'react';
import { Link } from 'react-router-dom';
import { signInWithGoogle, getUserFromStorage } from '../firebaseService';

// Import images properly
const desktopBanner = `${process.env.PUBLIC_URL}/homePagebanner.png`;
const mobileBanner = `${process.env.PUBLIC_URL}/homePagebannerPhone.png`;

const Home = () => {
  const handleStartLearning = async () => {
    // Check if user is already logged in
    const currentUser = getUserFromStorage();
    
    if (currentUser) {
      // User is already logged in, go directly to start-practice
      window.location.href = '/start-practice';
    } else {
      // User is not logged in, show login popup
      const result = await signInWithGoogle();
      if (result.success) {
        // After successful login, navigate to start-practice page
        window.location.href = '/start-practice';
      } else {
        alert('Login failed. Please try again.');
      }
    }
  };

  const handleIELTSPTEPractice = () => {
    window.location.href = 'http://ieltspte.heygerman.org/';
  };

  return (
    <div className="page">
      <style jsx>{`
        .hero-section {
          position: relative;
          padding: 80px 0 120px 0;
          color: white;
          overflow: hidden;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
        
        /* Desktop background - when text is left aligned */
        @media (min-width: 1024px) {
          .hero-section {
            background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url("${desktopBanner}");
            background-size: cover;
            background-position: center;
          }
        }
        
        /* Mobile background - when text is center aligned */
        @media (max-width: 1023px) {
          .hero-section {
            background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url("${mobileBanner}");
            background-size: cover;
            background-position: center;
            padding: 60px 0 80px 0;
          }
        }
        
        @media (min-width: 1024px) {
          .hero-content {
            transform: translateX(20%);
            text-align: left;
          }
          
          .hero-content p {
            margin: 0 0 40px 0 !important;
          }
          
          .hero-content .button-container {
            justify-content: flex-start !important;
          }
        }
        
        @media (max-width: 1023px) {
          .hero-content {
            text-align: center;
          }
          
          .hero-content .button-container {
            justify-content: center !important;
          }
        }
      `}</style>
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="hero-content" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h1 style={{ 
              fontSize: '3.5rem', 
              fontWeight: '900', 
              marginBottom: '24px',
              lineHeight: '1.1',
              letterSpacing: '-0.02em'
            }}>
              Master German with HeyGerman
            </h1>
            <p style={{ 
              fontSize: '1.25rem', 
              lineHeight: '1.6', 
              maxWidth: '600px', 
              margin: '0 auto 40px auto',
              opacity: '0.95'
            }}>
              Embark on your German language journey with our comprehensive resource. 
              Learn essential vocabulary, grammar, and practice with interactive exercises.
            </p>
            <div className="button-container" style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button 
                onClick={handleStartLearning}
                style={{
                  display: 'inline-block',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  padding: '16px 32px',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(76, 175, 80, 0.4)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(76, 175, 80, 0.5)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(76, 175, 80, 0.4)';
                }}
              >
                Start Learning German
              </button>

              <button 
                onClick={handleIELTSPTEPractice}
                style={{
                  display: 'inline-block',
                  backgroundColor: '#FF6B35',
                  color: 'white',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  padding: '16px 32px',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(255, 107, 53, 0.4)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(255, 107, 53, 0.5)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(255, 107, 53, 0.4)';
                }}
              >
                IELTS / PTE Practice Start Now...
              </button>
              
                            <Link 
                to="/consultation" 
                style={{
                  display: 'inline-block',
                  backgroundColor: 'transparent',
                  color: 'white',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  padding: '16px 32px',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  border: '2px solid white',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(255, 255, 255, 0.2)'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(255, 255, 255, 0.3)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(255, 255, 255, 0.2)';
                }}
              >
                Book Consultation
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ 
        padding: '80px 0', 
        backgroundColor: '#f8f9fa' 
      }}>
        <div className="container">
          <div style={{ 
            maxWidth: '800px', 
            margin: '0 auto 60px auto', 
            textAlign: 'center' 
          }}>
            <h2 style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold', 
              color: '#333', 
              marginBottom: '20px' 
            }}>
              What You'll Learn
            </h2>
            <p style={{ 
              fontSize: '1.2rem', 
              color: '#666', 
              lineHeight: '1.6' 
            }}>
              Our comprehensive course covers the fundamentals of German, preparing you 
              for everyday conversations and basic communication.
            </p>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '40px' 
          }}>
            <div style={{
              backgroundColor: 'white',
              padding: '40px 32px',
              borderRadius: '16px',
              textAlign: 'center',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              border: '1px solid #e2e8f0',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 0, 0, 0.12)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: 'rgba(102, 126, 234, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px auto',
                color: '#667eea'
              }}>
                <span style={{ fontSize: '2.5rem' }}>📚</span>
              </div>
              <h3 style={{ 
                fontSize: '1.5rem', 
                fontWeight: 'bold', 
                color: '#333', 
                marginBottom: '16px' 
              }}>
                Vocabulary
              </h3>
              <p style={{ 
                color: '#666', 
                lineHeight: '1.6',
                fontSize: '1rem'
              }}>
                Build a foundation with essential German words and phrases for daily conversations.
              </p>
            </div>

            <div style={{
              backgroundColor: 'white',
              padding: '40px 32px',
              borderRadius: '16px',
              textAlign: 'center',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              border: '1px solid #e2e8f0',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 0, 0, 0.12)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: 'rgba(102, 126, 234, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px auto',
                color: '#667eea'
              }}>
                <span style={{ fontSize: '2.5rem' }}>✏️</span>
              </div>
              <h3 style={{ 
                fontSize: '1.5rem', 
                fontWeight: 'bold', 
                color: '#333', 
                marginBottom: '16px' 
              }}>
                Grammar
              </h3>
              <p style={{ 
                color: '#666', 
                lineHeight: '1.6',
                fontSize: '1rem'
              }}>
                Understand basic sentence structure and grammar rules with clear explanations.
              </p>
            </div>

            <div style={{
              backgroundColor: 'white',
              padding: '40px 32px',
              borderRadius: '16px',
              textAlign: 'center',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              border: '1px solid #e2e8f0',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 0, 0, 0.12)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: 'rgba(102, 126, 234, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px auto',
                color: '#667eea'
              }}>
                <span style={{ fontSize: '2.5rem' }}>🎯</span>
              </div>
              <h3 style={{ 
                fontSize: '1.5rem', 
                fontWeight: 'bold', 
                color: '#333', 
                marginBottom: '16px' 
              }}>
                Practice
              </h3>
              <p style={{ 
                color: '#666', 
                lineHeight: '1.6',
                fontSize: '1rem'
              }}>
                Reinforce your learning with interactive quizzes and practical exercises.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ 
        padding: '80px 0', 
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div className="container">
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h2 style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold', 
              marginBottom: '20px' 
            }}>
              Ready to Start Your German Journey?
            </h2>
            <p style={{ 
              fontSize: '1.2rem', 
              marginBottom: '40px', 
              opacity: '0.95',
              lineHeight: '1.6'
            }}>
              Join thousands of people who are learning German right now.
            </p>
            
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button 
                onClick={() => console.log('YouTube')}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  backgroundColor: '#ff4757',
                  color: 'white',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  padding: '12px 24px',
                  borderRadius: '25px',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(255, 71, 87, 0.25)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(255, 71, 87, 0.4)';
                  e.target.style.backgroundColor = '#ff3742';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(255, 71, 87, 0.25)';
                  e.target.style.backgroundColor = '#ff4757';
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                YouTube
              </button>
              
              <button 
                onClick={() => console.log('WhatsApp')}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  backgroundColor: '#2ed573',
                  color: 'white',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  padding: '12px 24px',
                  borderRadius: '25px',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(46, 213, 115, 0.25)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(46, 213, 115, 0.4)';
                  e.target.style.backgroundColor = '#26d366';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(46, 213, 115, 0.25)';
                  e.target.style.backgroundColor = '#2ed573';
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
                </svg>
                WhatsApp
              </button>
              
              <button 
                onClick={() => console.log('Telegram')}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  backgroundColor: '#54a0ff',
                  color: 'white',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  padding: '12px 24px',
                  borderRadius: '25px',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(84, 160, 255, 0.25)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(84, 160, 255, 0.4)';
                  e.target.style.backgroundColor = '#3867d6';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(84, 160, 255, 0.25)';
                  e.target.style.backgroundColor = '#54a0ff';
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
                Telegram
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;